import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { ClaimFormData } from "../types";

export const useClaimSubmission = (contactId: string, onSuccess?: () => void) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (data: ClaimFormData) => {
    setIsSubmitting(true);
    try {
      const { error } = await supabase.from('claims').insert({
        user_id: contactId,
        claim_type: data.claim_type,
        incident_date: data.incident_date,
        description: data.description
      });

      if (error) throw error;

      toast({
        title: "Claim submitted successfully",
        description: "Your agent will process your claim shortly.",
      });
      
      if (onSuccess) {
        onSuccess();
      }

      return true;
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error submitting claim",
        description: "Please try again later.",
      });
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isSubmitting,
    handleSubmit
  };
};